import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { Router } from '@angular/router';
import { FormBuilder, Validators, ValidatorFn, FormGroup, AbstractControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BsModalService } from 'ngx-bootstrap';
import { regexValidators } from 'src/app/validation/validator';

@Component({
  selector: 'app-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.scss']
})
export class UserPasswordComponent implements OnInit {
    isLoading: boolean;
  pwForm: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.pwForm = this.formBuilder.group({

      oldpw: ["", Validators.required],
      password: ['', Validators.compose([Validators.pattern(regexValidators.password),
        Validators.required])],
      confirmPassword: ['', Validators.compose([
        Validators.pattern(regexValidators.password),
        Validators.required,
        this.equalto('password'),
      ])],
    }, {validator: this.checkPasswords});
  }

  ngOnInit() {
  }
  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    let pass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value;

    return pass === confirmPass ? null : {notSame: true};
  }

  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

      let input = control.value;

      let isValid = control.root.value[field_name] == input;
      if (!isValid) {
        return {'equalTo': {isValid}};
      } else {
        return null;
      }
    };
  }


  change() {
    this.isLoading = true;
    let req = {
      id: JSON.parse(localStorage.getItem('user')).id,
      newPassword: this.pwForm.controls.confirmPassword.value,
      oldPassword: this.pwForm.controls.oldpw.value,
    }
    this.userService.chnagePassword(req).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.isLoading = false;
          this.pwForm.reset();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.isLoading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  toggleFieldTextType() {

  }

}
